import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private router: Router,
	) {}

	/**
	 * Verifica si la ruta puede ser activada.
	 * @returns `true` si el usuario está autenticado, de lo contrario redirige al login.
	 */
	canActivate(): boolean {
		const isAuth = this.authService.isAuthenticated();

		if (isAuth) {
			return true;
		}

		this.router.navigate(['/login']);
		return false;
	}
}

/*
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
// import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard {
    constructor(protected authService: AuthService) {}

    // canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    //     if (!this.checkAuthRoles(route)) return false;

    //     if (this.authService.isJwtExpired()) {
    //         if (this.authService.isRefreshTokenValid()) {
    //             return new Observable<boolean>((obs) => {
    //                 this.authService.refreshToken().subscribe({
    //                     next: () => obs.next(true),
    //                     error: () => {
    //                         this.authService.logout();
    //                         obs.next(false);
    //                     },
    //                 });
    //             });
    //         } else {
    //             this.authService.logout();
    //             return false;
    //         }
    //     } else {
    //         return true;
    //     }
    // }

    // checkAuthRoles(route: ActivatedRouteSnapshot): boolean {
    //     const jwtToken = this.authService.getJwtToken();
    //     const refreshToken = this.authService.getRefreshToken();

    //     if (!jwtToken) {
    //         console.log('No JWT Token found in local storage');
    //         this.authService.logout();
    //         return false;
    //     }

    //     if (!refreshToken) {
    //         console.log('No Refresh Token found in local storage');
    //         this.authService.logout();
    //         return false;
    //     }

    //     const expectedRoles = route.data['roles'];
    //     const token = jwtDecode<{ roles: string[] }>(jwtToken);
    //     const userRoles = token.roles || [];

    //     if (!expectedRoles) {
    //         // No expected role found on route
    //         return true;
    //     }

    //     for (const expectedRole of expectedRoles) {
    //         if (userRoles.includes(expectedRole)) {
    //             // User has the required role
    //             return true;
    //         }
    //     }
    //     console.log('User does not have the required role to access this page');
    //     return false;
    // }
}*/
